import Vue from 'vue'

Vue.use({
    install() {
        Vue.prototype.$loading = function (value) {
            if (value !== null)
                this.$store.dispatch('local/set', { key: 'loading', value })
            return this.$store.getters['local/settings']('loading')
        }
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/loading.js